import { render, staticRenderFns } from "./yesPagination.vue?vue&type=template&id=2dcaa1aa"
import script from "./yesPagination.vue?vue&type=script&lang=js"
export * from "./yesPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports